module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'propertiesForm',
    ],

    config: {
        entityContext: 'trips',
        preventClearOnCancel: true,
        updateTabTitleForFieldCodes: {
            title: true,
            tripStart: true,
        },
        updateTabTitleTabContentLocator: '<< base_tabStrip_tabContent',
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bosch_trips': true,
        },
    },
}